import isFunction from 'lodash/isFunction';
import './toggleSimpleSelectBox.scss';

class toggleSimpleSelectBox {
    constructor(imagesService, dataService, $scope, $rootScope) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.imagesService = imagesService;
        this.dataService = dataService;
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    toggleSelected(id) {
        this.selectedOptions = this.selectedOptions ? null : id;

        this.dataService.updateSelectedOptions(
            this.defaultSelectedIdFieldName, [this.selectedOptions],
            false,
        );
        this.$rootScope.$emit('colorChangeEvent');
    }

    isSelected() {
        return !!this.selectedOptions;
    }
}

toggleSimpleSelectBox.$inject = ['imagesService', 'dataService', '$scope', '$rootScope'];

export default toggleSimpleSelectBox;